import angular from 'angular'
import { login } from 'redevConfig'
const enterPage = (login && login.page) || ''

const loginPage = enterPage ? require(`redevelopment/main/login/${enterPage.templateName}`) : require('./views/login.html')
const loginCtrl = enterPage ? require(`redevelopment/main/login/${enterPage.controllerName}`) : require('./loginCtrl')


export default angular
    .module('app.login', [])
    .config(['$stateProvider', function config ($stateProvider) {
        $stateProvider.state('login', {
            url: '/login',
            template: loginPage,
            controller: 'loginCtrl',
            title: '登录',
        })
    }])
    .controller('loginCtrl', loginCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/main/login/index.js